import {UserTypes} from './user-types.enum'
import {FlagPrevisao} from './flag-previsao.enum'

export {
  UserTypes,
  FlagPrevisao
}
